import { createAction } from '@reduxjs/toolkit';
import { CustomerContactInformation, ErrorObject } from 'types';

export const fetchCustomerContacts = createAction('CUSTOMER_CONTACTS/FETCH_CUSTOMER_CONTACTS');
export const fetchCustomerContactsRequest = createAction(
  'CUSTOMER_CONTACTS/FETCH_CUSTOMER_CONTACTS_REQUEST'
);
export const fetchCustomerContactsFailure = createAction<ErrorObject>(
  'CUSTOMER_CONTACTS/FETCH_CUSTOMER_CONTACTS_FAILURE'
);
export const fetchCustomerContactsSuccess = createAction<CustomerContactInformation>(
  'CUSTOMER_CONTACTS/FETCH_CUSTOMER_CONTACTS_SUCCESS'
);

type UpsertCustomerContactsPayload = Partial<CustomerContactInformation>;

export const upsertCustomerContacts = createAction<UpsertCustomerContactsPayload>(
  'CUSTOMER_CONTACTS/UPSERT_CUSTOMER_CONTACTS'
);
export const upsertCustomerContactsRequest = createAction(
  'CUSTOMER_CONTACTS/UPSERT_CUSTOMER_CONTACTS_REQUEST'
);
export const upsertCustomerContactsFailure = createAction<ErrorObject>(
  'CUSTOMER_CONTACTS/UPSERT_CUSTOMER_CONTACTS_FAILURE'
);
export const upsertCustomerContactsuccess = createAction<CustomerContactInformation>(
  'CUSTOMER_CONTACTS/UPSERT_CUSTOMER_CONTACTS_SUCCESS'
);
